module.exports = "/_next/static/images/buyers_10_ru-813bb350b6942e71382d24f5996532b8.png";